import DB from './db'

export default function () {
  return DB()
}



// WEBPACK FOOTER //
// ../webmango-db/browser.js